/**
 * Обертка рисковой сцены (по идее любой и красночерной и 4х карточной)
 * @param {RiskScene} riskScene - готовая рисковая сцена
 * @param {Stream} $ticker - поставщик dt (для обновлений если это требуется в сцене)
 * */

export default function RiskView(
    riskScene,
    parent,
    $ticker,
)
{
    const space = parent.child( "risk" );
    
    if (!riskScene) {
        return {
            space
        }
    }
    
    // карта, которую выбрал игрок
    const $choiceOut = space.s( "choiceOut" );
    
    const fakeController = {
        cardSelected(card, step) {
            $choiceOut.next( card );
        },
    };
    
    riskScene.controller = fakeController;
    
    riskScene.visible = false;
    
    if ( riskScene.update )
    {
        $ticker.subscribe(dt => {
            riskScene.update(dt);
        });
    }
    
    const $startComplete = space.s( "startComplete" );
    // вход в риск
    // требуются текущий выигрыш и тот который будет
    // требуется история карт
    space.s( "startRound" ).subscribe( enter => {
        riskScene.visible = true;
        riskScene.startRound( enter, $startComplete );
    } );
    
    
    const $enterComplete = space.s( "enterComplete" );
    
    // вход - отрисовка каких-то вещей которые на затрагиваются в отрисовке в startRound()
    space.s( "enter" ).subscribe( state => {
        riskScene.visible = true;
        riskScene.resume(state, () => {
            $enterComplete.next();
        });
    } );
    
    // выход - отключение звука мелькающей карты и т.п.
    space.s( "leave" ).subscribe( state => {
        console.log('LEAVE:', state);
        riskScene.pause(state);
        riskScene.visible = false;
    } );
    
    // сигнализирует о том что длительный показ исхода риска польностью завершился
    const $showComplete = space.s( "showComplete" );
    
    // требуется результат и сумма выигрыша которую отобразить и ту которую показать как следующий возможной выигрыш
    // могут быть нулями если игрок проиграл
    space.s( "result" ).subscribe( result => riskScene.showRiskResult( result, () => $showComplete.next() ) );
    
    space.s( "collect" ).subscribe(() => riskScene.disableInteraction());
    
    // игрок сделал выбор - отобразилась информация о том какой цвет он выбрал (даьше ничего не происходит)
    space.s( "choiceIn" ).subscribe( choice => {
        riskScene.onCardSelect( choice );
        riskScene.disableInteraction();
    } );
    
    return {
        view:riskScene,
        space,
    }
}



// WEBPACK FOOTER //
// ./src/library/risk_view.es6